import { isToday } from 'date-fns';
import { TZDate } from '@date-fns/tz';

const RESOURCE_TIME_ZONE = 'Europe/Stockholm';

function removeTimeFromDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function getScheduleDurationInHours(schedule) {
  return Number(schedule?.to) - Number(schedule?.from);
}

function getScheduleDurationInDays(startDate, endDate) {
  if (!endDate) return 0;

  const startDateOnly = removeTimeFromDate(startDate);
  const endDateOnly = removeTimeFromDate(endDate);

  // Calculate difference in days
  const msPerDay = 1000 * 60 * 60 * 24;
  const diffInMs = endDateOnly - startDateOnly;
  return diffInMs / msPerDay;
}

function buildSlotStart(selectedDate, fromHour) {
  const y = selectedDate.getFullYear();
  const m = selectedDate.getMonth();
  const d = selectedDate.getDate();
  const h = Number(fromHour);
  return new TZDate(y, m, d, h, 0, 0, RESOURCE_TIME_ZONE);
}

export const mapDataForBackend = (data) => {
  const date = new Date(data?.date);

  let bookingStart;
  if (isToday(date) && data?.scheduleType === 'daily') {
    bookingStart = new Date();
    bookingStart.setUTCSeconds(0, 0);
    bookingStart.setUTCMinutes(bookingStart.getUTCMinutes() + 2);
  } else {
    bookingStart = buildSlotStart(date, data?.from);
  }

  return {
    date: new Date(bookingStart.getTime()).toISOString(),
    confirmed: true,
    resourceId: data?.resourceId,
    duration: {
      ...(data?.scheduleType === 'slots' && {
        hours: getScheduleDurationInHours(data),
      }),
      ...(data?.scheduleType === 'daily' && {
        days: getScheduleDurationInDays(data?.date, data?.endDate),
      }),
    },
  };
};
